import React, { useState, useRef, useEffect } from "react";
import { NavLink, Link } from "react-router-dom";
import "./NavBar.css";

import { useNavigate } from "react-router-dom";

import { FaShoppingCart } from "react-icons/fa";
import { FaSearch } from "react-icons/fa";
import { FaTimes } from "react-icons/fa";


import { useCart } from "../CartProvider";
import { useLogin } from "../LoginProvider";

import Login from "./Login";
import Register from "./Register";
import ForgotPassword from "./ForgotPassword";

import { collection, getDocs, limit, query as fbQuery, where , doc , getDoc} from "firebase/firestore";
import { db } from "../firebase";

const algoliasearch = require('algoliasearch')
const client = algoliasearch('Z0779QG1XQ', 'e2b9561e29bba76bc92396121c867b38')
const index = client.initIndex('algolia_dollarstore')

function useIsMobile(breakpoint = 900) {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth <= breakpoint : false
  );
  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= breakpoint);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [breakpoint]);
  return isMobile;
}

// fields-map que tu contrôles (exemple)
const map = {
  imageField: "ImageUrl",          // ou "ImageUrl"
  oldPriceField: "OldPrice",
  saleField: "OnSale",
  idField: "id",              // si tes docs ont un champ id custom; sinon on utilisera doc.id
  titleField: "Name",
  categoryField: "category",       // URL vers image principale
  priceField: "Stores",
  stockField: "QuantityAvailable",
};

// helper pour lire des chemins profonds "a.b.c"
const get = (obj, path) =>
  path?.split(".").reduce((o, k) => (o && o[k] !== undefined ? o[k] : undefined), obj);

// function shapeProduct(id, d, map) {
//   return {
//     id,
//     title: d?.Name ?? "...",
//     category: (get(d, map.categoryField) ?? "").toString(),
//     image: get(d, map.imageField) ?? "",
//     price: Number(d?.Stores?.Cassablanca?.SalePrice ?? 0),
//     oldPrice: Number(get(d, map.oldPriceField) ?? 0),
//     stock: Number(d?.Stores?.Cassablanca?.Quantity ?? 0),
//     onSale: Boolean(get(d, map.saleField) ?? false),
//     IsPack: Boolean(d?.HasChilds ?? false),
//     Images: d?.Images ?? [],
//     Description: d?.Description ?? "Pas de description...",
//     SubCategorie: d?.Categorie?.SubCategorie?.Id ?? null,
//   };
// }

function shapeProduct(id , doc, map) {
  const d = doc.data ? doc.data() : doc; // robuste si on passe déjà un objet
  return {
    id,
    title: d?.Name,
    category: (d?.[map.categoryField] ?? "").toString(),
    image: d?.[map.imageField] ?? "",
    price: Number(d?.Stores?.Cassablanca?.SalePrice ?? 0),
    oldPrice: Number(d?.[map.oldPriceField] ?? 0),
    stock: Number(
    Number(d?.Stores?.Cassablanca?.Quantity ?? 0) +
    Number(d?.Stores?.Dekon?.Quantity ?? 0) +
    Number(d?.Stores?.Baguida?.Quantity ?? 0)
  ) - Number(3),
    InShip: Number(d?.QuantityInPo ?? 0) + Number(d?.QuantityInShpping ?? 0),
    onSale: Boolean(d?.[map.saleField] ?? false),
    IsPack: Boolean(d?.HasChilds ?? false),
    Images: d?.Images ?? [],
    Description: d?.Description ?? "Pas de description...",
    SubCategorie: d?.Categorie?.SubCategorie?.Id ?? null,
    ParentId: (d?.ParentId == null || String(d.ParentId).trim() === '') ? doc.id : d.ParentId , 
    MaxiDiscount: Number(d?.MaxiDiscount ?? 0),
    GetDiscount: Boolean(d?.GetDiscount ?? false),
    ApplyInvitation: Boolean(d?.ApplyInvitation ?? false),
  };
}


export default function NavBar() {
  const navigate = useNavigate();
  const isMobile = useIsMobile()
  const [confirmLogoutOpen, setConfirmLogoutOpen] = useState(false);
  const [authModal, setAuthModal] = useState(null); // "login" | "register" | null
  const { user, logout } = useLogin();
  const [openU, setOpenU] = useState(false);
  const menuRef = useRef(null);

  const close = () => setAuthModal(null);
  const switchTo = (target) => setAuthModal(target); // "login" / "register"

  const [showSearch , setShowSearch] = useState(false);
  


  const [open, setOpen] = useState(false);

  const { cart} = useCart();
  const items = Object.values(cart);

  // badges (exemple)
  const cartCount = 2;

const [term, setTerm] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openPanel, setOpenPanel] = useState(false);
  const searchBoxRef = useRef(null);
  const debounceRef = useRef(null);

  // Fermer le panneau quand on clique en dehors
  useEffect(() => {
    const onDocClick = (e) => {
      if (searchBoxRef.current && !searchBoxRef.current.contains(e.target)) {
        setOpenPanel(false);
      }
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, []);

  // Requête (debounce 300ms)
  useEffect(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current);

    if (!term || term.trim().length < 2) {
      setResults([]);
      return;
    }

    debounceRef.current = setTimeout(async () => {
      try {
        setLoading(true);
        const t = term.trim().toUpperCase(); // SearchKeys sont en MAJ
      //   const q = fbQuery(
      //   collection(db, "items"),
      //   where("SearchKeys", "array-contains", t),
      //   where("IsProductValidated","==", true),
      //   limit(30)
      // );

      index.search(t, {
          attributesToRetrieve: ['Name', 'UPC'],
          hitsPerPage: 200,
        }).then(async ({ hits }) => {
            const promises = hits.map(async (item) => {
            const docRef = doc(db, "items", item.objectID);
            const docSnap = await getDoc(docRef);

            if (!docSnap.exists()) return null;

            const data = docSnap.data();
            if (data?.IsProductValidated !== true) return null;

            return { ...data, id: item.objectID };
          });

          const results = (await Promise.all(promises)).filter(Boolean);

          // results contient déjà tes docs validés
          const rows = results.map((data) => shapeProduct(data.id, data, map));

          setResults(rows);
          setOpenPanel(true);
        });
      
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    }, 300);

    return () => clearTimeout(debounceRef.current);
  }, [term]);

  const handleDetails = (item) => {
    navigate(`/details/${item.id}`, { state: { item } });
  };

//   const handleSubmit = (e) => {
//   e.preventDefault(); // empêche le rechargement
//   if (term.trim()) {
//     navigate(`/search?query=${encodeURIComponent(term)}`);
//   }
// };

const handleSubmit = (e) => {
  e.preventDefault(); // empêcher reload
  if (term.trim()) {
    setOpenPanel(false); // ✅ on ferme le panneau avant de naviguer
    navigate(`/search?query=${encodeURIComponent(term)}`);
  }
};


  return (
    <>
    <header className="navbar">
      <div className="nav-inner">
        {/* Burger (mobile) */}
        {/* Burger / Close (mobile) */}
       {
        showSearch === false 
        ?
        <button
        className="nav-burger"
        aria-label={open ? "Fermer le menu" : "Ouvrir le menu"}
        aria-expanded={open}
        onClick={() => setOpen(v => !v)}
      >
        {open ? (
          <FaTimes size={22} />
        ) : (
          <>
            <span />
            <span />
            <span />
          </>
        )}
        
      </button>
        :
        ''
       }
      {
        showSearch === false ?
        
        <img onClick={() => navigate('/')} src="/images/dollarstore.jpg" alt="Dollar Store" className="logo-img" />
        :
        ''
      }

        {/* Logo */}
        {/* Logo */}
      <Link to="/" className="nav-logo">
        
        <span className="logo-text">
          DOLLAR <span className="accent">STORE</span>
        </span>
      </Link>

        
        {showSearch ? (
            <div className="search-nav-div" ref={searchBoxRef}>
              <form onSubmit={handleSubmit}>
                <input
                type="text"
                className="search-nav-input"
                placeholder="Rechercher un produit…"
                value={term}
                onFocus={() => results.length && setOpenPanel(true)}
                onChange={(e) => setTerm(e.target.value)}
              />
              </form>

              {/* Panneau de résultats */}
              {openPanel && (results.length > 0 || loading) && (
                <div className="search-panel">
                  {loading && <div className="search-item muted">Recherche…</div>}
                  {!loading && results.length === 0 && (
                    <div className="search-item muted">Aucun résultat</div>
                  )}
                  {!loading &&
                    results.map((it) => (
                      <div
                        key={it.id}
                        className="search-item"
                        onClick={() => {
                          setTerm("");
                          setOpenPanel(false);
                          setShowSearch(false);
                          handleDetails(it);
                        }}
                      >
                        <img
                          src={it.image || "/placeholder.webp"}
                          alt={it.title}
                          className="search-thumb"
                        />
                        <div className="search-texts">
                          <div className="title">{Number(it.price)} FCFA</div>
                          {it.price != null && (
                            <div className="price">{it.title}</div>
                          )}
                        </div>
                      </div>
                    ))}
                  
                </div>
              )}
            </div>
          ) : null}


        {/* Menu centre (desktop) */}
        <nav className="nav-center">
         {
          showSearch === true 
          ?
          ''
          :
          <>
           <NavLink end to="/" className={({isActive}) => `nav-link ${isActive ? "active" : ""}`}>
            Acceuil
          </NavLink>
          <NavLink to="/products" className={({isActive}) => `nav-link ${isActive ? "active" : ""}`}>
            Nos Produits
          </NavLink>
          <NavLink to="/promotions" className={({isActive}) => `nav-link ${isActive ? "active" : ""}`}>
            En Promotions
          </NavLink>
          
          <NavLink to="/about" className={({isActive}) => `nav-link ${isActive ? "active" : ""}`}>
            Qui Sommes Nous ?
          </NavLink>
          </>
         }
        </nav>

        {/* Icônes à droite */}
        <div className="nav-right">
          {
            showSearch === false 
            ?
            <button className="icon-btn" aria-label="Rechercher" onClick={() => setShowSearch(true)}>
            <FaSearch size={22} aria-hidden="true" />
          </button>
            :
      <button className="icon-btn" aria-label="Rechercher" onClick={() => setShowSearch(false)}>
                  <FaTimes size={22} aria-label="Fermer" />
                </button>
          }
          
        {
  !showSearch ? (
    <>
      <Link 
        to="/cart" 
        className="icon-btn badge-wrap icon-btn-shop" 
        aria-label={`Panier, ${cartCount} articles`}
      >
        <FaShoppingCart size={28} className="cart-logo" />
        <span className="badge">{items.length}</span>
      </Link>

      {
        !isMobile ?
        user?.name ? (
        <div
          ref={menuRef}
          style={{ position: "relative", display: "inline-block" }}
          className="mobile-menu-hd"
        >
          {/* Avatar + nom */}
          <div
            onClick={() => setOpenU((o) => !o)}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 6,
              cursor: "pointer",
              userSelect: "none",
            }}
          >
            <div
              style={{
                width: 30,
                height: 30,
                borderRadius: "50%",
                background: "#2563eb",
                color: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 8,
                fontWeight: "bold",
                overflow: "hidden",
              }}
            >
              {user.photo ? (
                <img
                  src={user.photo}
                  alt={user.name}
                  style={{ width: "100%", height: "100%", objectFit: "contain" }}
                />
              ) : (
                user.name.slice(0 , 1).toUpperCase()
              )}
            </div>
            <span style={{ fontSize: 14, fontWeight: 500 }}>{user.name}</span>
          </div>

          {/* Dropdown */}
          {openU && (
            <div
              style={{
                position: "absolute",
                top: "100%",
                left: "50%",
                transform: "translateX(-50%)",
                marginTop: 8,
                background: "#fff",
                borderRadius: 8,
                boxShadow: "0 4px 16px rgba(0,0,0,0.15)",
                minWidth: 180,
                zIndex: 1000,
                overflow: "hidden",
              }}
            >
              <NavLink to={{ pathname: "/compte"}} state={{ from: "compte" }} style={itemStyle}>Mon Compte</NavLink>
              <NavLink to={{ pathname: "/compte"}} state={{ from: "commande" }} style={itemStyle}>Mes Commandes</NavLink>
              <NavLink to={{ pathname: "/compte"}} state={{ from: "support" }} style={itemStyle}>Support</NavLink>
              <button style={{ ...itemStyle, color: "#dc2626" }} onClick={() => setConfirmLogoutOpen(true)}>
                Se déconnecter
              </button>
            </div>
          )}
        </div>
      ) : (
        <button onClick={() => setAuthModal("login")} className="login-nav-button">
          connexion
        </button>
      )
        :
        ''
      }
    </>
  ) : null
}

          
        </div>
      </div>

      {/* Menu mobile déroulant */}
      <nav className={`mobile-menu ${open ? "open" : ""}`}>
        <NavLink end to="/" className="mobile-link" onClick={() => setOpen(false)}>Acceuil</NavLink>
        <NavLink to="/products" className="mobile-link" onClick={() => setOpen(false)}>Nos Produits</NavLink>
        <NavLink to="/promotions" className="mobile-link" onClick={() => setOpen(false)}>Promotions</NavLink>
        <NavLink to="/about" className="mobile-link" onClick={() => setOpen(false)}>Qui sommes nous?</NavLink>

        <hr />

        {user?.name ? (
        <div
          ref={menuRef}
          style={{ position: "relative", display: "inline-block" }}
        >
          {/* Avatar + nom */}
          <div
            onClick={() => setOpenU((o) => !o)}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 6,
              cursor: "pointer",
              userSelect: "none",
              marginBottom: 40,
              marginTop: 20
            }}
          >
            <div
              style={{
                width: 60,
                height: 60,
                borderRadius: "50%",
                background: "#2563eb",
                color: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 18,
                fontWeight: "bold",
                overflow: "hidden",
              }}
            >
              {user.photo ? (
                <img
                  src={user.photo}
                  alt={user.name}
                  style={{ width: "100%", height: "100%", objectFit: "contain" }}
                />
              ) : (
                user.name.slice(0 , 1).toUpperCase()
              )}
            </div>
            <span style={{ fontSize: 14, fontWeight: 500 }}>{user.name.slice(0 , 10)}</span>
          </div>

          {/* Dropdown */}
          {openU && (
            <div
              style={{
                position: "absolute",
                top: "100%",
                left: "50%",
                transform: "translateX(-50%)",
                marginTop: 8,
                background: "#fff",
                borderRadius: 8,
                boxShadow: "0 4px 16px rgba(0,0,0,0.15)",
                minWidth: 180,
                zIndex: 1000,
                overflow: "hidden",
              }}
            >
              <NavLink to={{ pathname: "/compte"}} state={{ from: "compte" }} style={itemStyle}>Mon Compte</NavLink>
              <NavLink to={{ pathname: "/compte"}} state={{ from: "commande" }}  style={itemStyle}>Mes Commandes</NavLink>
              <NavLink to={{ pathname: "/compte"}} state={{ from: "support" }}  style={itemStyle}>Support</NavLink>
              <button style={{ ...itemStyle, color: "#dc2626" }} onClick={() => setConfirmLogoutOpen(true)}>
                Se déconnecter
              </button>
            </div>
          )}
        </div>
      ) : (
        <button onClick={() => setAuthModal("login")} className="login-nav-button">
          connexion
        </button>
      )}
      </nav>
    </header>

    <Login
      isOpen={authModal === "login"}
      onClose={close}
      onSwitch={switchTo}
    />
    <Register
      isOpen={authModal === "register"}
      onClose={close}
      onSwitch={switchTo}
    />

    <ForgotPassword
  isOpen={authModal === "forgot"}
  onClose={close}
/>


    {confirmLogoutOpen && (
  <ConfirmDialog
    title="Confirmer la déconnexion"
    message="Voulez-vous vraiment vous déconnecter ?"
    confirmText="Oui, me déconnecter"
    cancelText="Annuler"
    onCancel={() => setConfirmLogoutOpen(false)}
    onConfirm={() => {
      setConfirmLogoutOpen(false);
      setOpenU(false);   // fermer le menu
      logout();          // ta fonction de logout
    }}
  />
)}

    </>
  );
}

// ---- à placer sous itemStyle (en bas du fichier) ----
function ConfirmDialog({ title, message, confirmText, cancelText, onCancel, onConfirm }) {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onCancel();
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onCancel]);

  return (
    <div className="modal-overlay" onMouseDown={onCancel} role="dialog" aria-modal="true">
      <div className="modal-card" onMouseDown={(e) => e.stopPropagation()}>
        <h4 className="modal-title">{title}</h4>
        <p className="modal-msg">{message}</p>
        <div className="modal-actions">
          <button className="btn-ghost" onClick={onCancel}>{cancelText || "Annuler"}</button>
          <button className="btn-danger" onClick={onConfirm}>{confirmText || "Confirmer"}</button>
        </div>
      </div>
    </div>
  );
}


const itemStyle = {
  display: "block",
  width: "100%",
  textAlign: "left",
  padding: "10px 14px",
  border: "none",
  background: "transparent",
  cursor: "pointer",
  fontSize: 14,
  textDecoration: "none", // 🔑 enlève le soulignement
  color: "black",         // 🔑 texte noir
};

